import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useShallow } from 'zustand/react/shallow';
import { Avatar } from '../components/Avatar';
import { IconClose, IconSearch } from '../components/Icons';
import { forwardMessage, sortedConversations, useChat, type MessageItem } from '../store/chat';

/** "Forward to…": picks one of the user's chats, sends the copy there and opens that chat. */
export function ForwardPicker({ m, authorName, onClose }: { m: MessageItem; authorName: string; onClose: () => void }) {
  const nav = useNavigate();
  const conversations = useChat(useShallow(sortedConversations));
  const [query, setQuery] = useState('');
  const q = query.trim().toLowerCase();
  const list = q
    ? conversations.filter((c) => c.peer.displayName.toLowerCase().includes(q) || c.peer.username?.toLowerCase().includes(q))
    : conversations;

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  const pick = (conversationId: string) => {
    void forwardMessage(conversationId, m, authorName);
    onClose();
    nav(`/c/${conversationId}`);
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal forward-picker" onClick={(e) => e.stopPropagation()} role="dialog" aria-label="Переслать">
        <div className="forward-head">
          <h2>Переслать</h2>
          <button className="icon-btn" onClick={onClose} aria-label="Закрыть">
            <IconClose />
          </button>
        </div>
        <div className="search">
          <IconSearch size={18} />
          <input type="search" placeholder="Поиск" value={query} onChange={(e) => setQuery(e.target.value)} autoCapitalize="none" />
        </div>
        <div className="forward-list">
          {list.map((c) => (
            <button key={c.id} className="conv-row" onClick={() => pick(c.id)}>
              <Avatar user={c.peer} size={42} />
              <span className="conv-name">{c.peer.displayName}</span>
            </button>
          ))}
          {list.length === 0 && <p className="muted forward-empty">{q ? 'Ничего не найдено' : 'Пока нет чатов'}</p>}
        </div>
      </div>
    </div>
  );
}
